import React, { useState, useRef, useEffect } from "react";
import LoadingBar from "react-top-loading-bar";
import TopBar from "../../sections/TopBar";
import Sidebar from "../../sections/Sidebar";
import "../../customCss/ManageOfficers.css";
import DataService from "../../services/data.service";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import NotFound from "../../images/no-data-found.jpeg";
import Spinner from "../../sections/Spinner";
import { TextField, Autocomplete } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";
import * as XLSX from "xlsx";

const plans = [
  { label: "Monthly", value: "monthly" },
  { label: "Yearly", value: "yearly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Bi-Weekly", value: "bi-weekly" },
  { label: "Weekly", value: "weekly" },
  { label: "Semi-Annual", value: "semi-annual" },
  { label: "2 Year", value: "2 year" },
];

const paymentModes = [
  { label: "Autopay", value: "Autopay" },
  { label: "Manual", value: "Manual" },
];

const ServicePurchased = () => {
  const ref = useRef();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [allServices, setAllServices] = useState([]);
  const [selectedService, setSelectedService] = useState({});
  const [deleteServicePopup, setDeleteServicePopup] = useState(false);
  const [editing, setEditing] = useState(false);
  const [addNewPopup, setAddNewPopup] = useState(false);
  const [toolName, setToolName] = useState("");
  const [toolEmail, setToolEmail] = useState("");
  const [toolPassword, setToolPassword] = useState("");
  const [toolAccountNumber, setToolAccountNumber] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [planDuration, setPlanDuration] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [toolCost, setToolCost] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [paymentMode, setPaymentMode] = useState(null);
  const exportToExcel = () => {
    if (!allServices || allServices.length === 0) {
      toast.error("No Data Available to Print");
      return;
    }

    setLoading(true);
    setTimeout(() => {
      const formattedData = allServices.map((item, index) => ({
        "S. No.": index + 1,
        "Tool Name": item?.toolName || "-",
        "Tool Email": item?.toolEmailId || "-",
        "Tool Password": item?.password || "-",
        "Tool Account": item?.accountNumber || "-",
        "Plan Duration": item?.planDuration || "-",
        "Payment Mode": item?.paymentMode || "-",
        "Start Date": item?.startDate
          ? moment(item?.startDate).format("MM/DD/YYYY")
          : "-",
        "Expiry Date": item?.expiryDate
          ? moment(item?.expiryDate).format("MM/DD/YYYY")
          : "-",
        "Tool Cost": item?.cost ? `$ ${item?.cost}` : "-",
        "Contact Name": item?.name || "-",
        "Contact Email": item?.email || "-",
        "Contact Phone": item?.phoneNo || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Tool Services");
      XLSX.writeFile(workbook, "All_Tool_Services.xlsx");

      setLoading(false);
    }, 1500);
  };

  useEffect(() => {
    document.title = "Manage Services || Officer Apps";
    window.scrollTo(0, 0);
    getAllServices();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  const getAllServices = () => {
    ref.current.continuousStart();
    setLoading(true);
    DataService.getToolDetails()
      .then((data) => {
        setAllServices(data?.data?.data);
        ref.current.complete();
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Failed to fetch Tool Details");
        console.error("Failed to fetch Tool details", error);
        ref.current.complete();
        setLoading(false);
      });
  };
  const resetFields = () => {
    setAddNewPopup(false);
    setToolName("");
    setPlanDuration(null);
    setExpiryDate(null);
    setStartDate(null);
    setToolCost("");
    setContactName("");
    setContactPhone("");
    setContactEmail("");
    setToolEmail("");
    setToolPassword("");
    setToolAccountNumber("");
    setSelectedService({});
    setPaymentMode(null);
    setEditing(false);
  };
  const setData = (item) => {
    setSelectedService(item);
    setEditing(true);
    setToolName(item?.toolName || "");
    setPlanDuration(
      plans?.find((p) => {
        const val = Array.isArray(item?.planDuration)
          ? item?.planDuration[0]
          : item?.planDuration;
        return p?.value?.toLowerCase() === val?.toLowerCase();
      }) || null,
    );
    setStartDate(item?.startDate ? dayjs(item?.startDate) : null);
    setExpiryDate(item?.expiryDate ? dayjs(item?.expiryDate) : null);
    setToolCost(item?.cost || "");
    setToolEmail(item?.toolEmailId || "");
    setToolPassword(item?.password || "");
    setToolAccountNumber(item?.accountNumber || "");
    setContactName(item?.name || "");
    setContactPhone(item?.phoneNo || "");
    setContactEmail(item?.email || "");
    setPaymentMode(
      paymentModes?.find((p) => p.value === item?.paymentMode) || null
    );
    setAddNewPopup(true);
  };
  const handleDeleteOfficer = () => {
    setBtnLoading(true);
    DataService.deleteTool(selectedService._id).then(
      () => {
        toast.success(`Tool details deleted successfully`);
        resetFields();
        getAllServices();
        setDeleteServicePopup(false);
        setBtnLoading(false);
      },
      (error) => {
        const resMessage = error?.response?.data?.message;
        setBtnLoading(false);
        toast.error(resMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnLoading(true);
    const data = {
      ...(planDuration?.value && { planDuration: [planDuration?.value] }),
      ...(expiryDate && { expiryDate }),
      ...(paymentMode?.value && { paymentMode: paymentMode?.value }),
      ...(toolName && { toolName }),
      ...(startDate && { startDate }),
      ...(toolCost && { cost: toolCost }),
      ...(toolEmail && { toolEmailId: toolEmail }),
      ...(toolPassword && { password: toolPassword }),
      ...(toolAccountNumber && { accountNumber: toolAccountNumber }),
      ...(contactName && { name: contactName }),
      ...(contactEmail && { email: contactEmail }),
      ...(contactPhone && { phoneNo: contactPhone }),
    };

    DataService.addNewTool(data)
      .then(() => {
        getAllServices();
        resetFields();
        toast.success("Tool details added successfully");
        setBtnLoading(false);
      })
      .catch((error) => {
        setBtnLoading(false);
        const resMessage = error?.response?.data?.message;
        toast.error(resMessage);
      });
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    setBtnLoading(true);
    const data = {
      ...(planDuration?.value && { planDuration: [planDuration?.value] }),
      ...(expiryDate && { expiryDate }),
      ...(paymentMode?.value && { paymentMode: paymentMode?.value }),
      ...(toolName && { toolName }),
      ...(startDate && { startDate }),
      ...(toolCost && { cost: toolCost }),
      ...(toolEmail && { toolEmailId: toolEmail }),
      ...(toolPassword && { password: toolPassword }),
      ...(toolAccountNumber && { accountNumber: toolAccountNumber }),
      ...(contactName && { name: contactName }),
      ...(contactEmail && { email: contactEmail }),
      ...(contactPhone && { phoneNo: contactPhone }),
    };

    DataService.updateTool(selectedService?._id, data)
      .then(() => {
        getAllServices();
        resetFields();
        toast.success("Tool details updated successfully");
        setBtnLoading(false);
      })
      .catch((error) => {
        setBtnLoading(false);
        const resMessage = error?.response?.data?.message;
        toast.error(resMessage);
      });
  };
  return (
    <>
      <LoadingBar color="#084e8a" ref={ref} height={5} />
      <div
        className={`main_layout ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
      >
        {addNewPopup && (
          <div className="popupOuter">
            <div className="popupInner">
              <i className="fas fa-times" onClick={resetFields} />
              <div className="popupHeader">
                <h3>{editing ? "Edit" : "Add New"} Tool Detail</h3>
              </div>
              <div className="popupBody py-4">
                <div className="mb-4">
                  <TextField
                    label="Tool Name"
                    variant="outlined"
                    fullWidth
                    type="text"
                    size="small"
                    value={toolName}
                    onChange={(e) => setToolName(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <Autocomplete
                    options={plans}
                    getOptionLabel={(option) => option?.label}
                    value={planDuration}
                    size="small"
                    sx={{ width: "100%", background: "#fff" }}
                    onChange={(event, newValue) => {
                      setPlanDuration(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Plan Duration"
                        variant="outlined"
                      />
                    )}
                  />
                </div>
                <div className="mb-4">
                  <Autocomplete
                    options={paymentModes}
                    getOptionLabel={(option) => option?.label}
                    value={paymentMode}
                    size="small"
                    sx={{ width: "100%", background: "#fff" }}
                    onChange={(event, newValue) => setPaymentMode(newValue)}
                    renderInput={(params) => <TextField {...params} label="Payment Mode" variant="outlined" />}
                  />
                </div>
                <div className="row mb-4">
                  <div className="col-sm-6">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Start Date"
                        required
                        sx={{ width: "100%" }}
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            size: "small",
                            sx: {
                              fontSize: "0.875rem",
                              "& .MuiInputBase-input": {
                                padding: "8px 10px",
                              },
                            },
                          },
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth size="small" />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="col-sm-6">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Expiry Date"
                        disablePast
                        sx={{ width: "100%" }}
                        value={expiryDate}
                        onChange={(newValue) => setExpiryDate(newValue)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            size: "small",
                            sx: {
                              fontSize: "0.875rem",
                              "& .MuiInputBase-input": {
                                padding: "8px 10px",
                              },
                            },
                          },
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth size="small" />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-sm-6">
                    <TextField
                      label="Tool Cost"
                      variant="outlined"
                      fullWidth
                      type="number"
                      size="small"
                      value={toolCost}
                      onChange={(e) => setToolCost(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <TextField
                      label="Tool Email ID"
                      variant="outlined"
                      fullWidth
                      type="text"
                      size="small"
                      value={toolEmail}
                      onChange={(e) => setToolEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-sm-6" style={{ position: "relative" }}>
                    <TextField
                      label="Tool Password"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type={showPassword ? "text" : "password"}
                      value={toolPassword}
                      onChange={(e) => setToolPassword(e.target.value)}
                    />
                    <i
                      className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"
                        }`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: 25,
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    />
                  </div>
                  <div className="col-sm-6">
                    <TextField
                      label="Tool Account No."
                      variant="outlined"
                      fullWidth
                      type="text"
                      size="small"
                      value={toolAccountNumber}
                      onChange={(e) => setToolAccountNumber(e.target.value)}
                    />
                  </div>
                </div>
                <input
                  type="text"
                  name="dummy-email"
                  autoComplete="off"
                  style={{ display: "none" }}
                />
                <input
                  type="password"
                  name="dummy-pass"
                  autoComplete="new-password"
                  style={{ display: "none" }}
                />

                <h5 className="mb-3">Contact Person Details</h5>
                <div className="row">
                  <div className="col-sm-4">
                    <TextField
                      label="Name"
                      variant="outlined"
                      fullWidth
                      type="text"
                      size="small"
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      label="Email"
                      variant="outlined"
                      fullWidth
                      type="text"
                      size="small"
                      value={contactEmail}
                      onChange={(e) => setContactEmail(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      label="Phone"
                      variant="outlined"
                      fullWidth
                      type="text"
                      size="small"
                      value={contactPhone}
                      onChange={(e) => setContactPhone(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="popupFooter">
                <button
                  className="btn btn-primary"
                  onClick={editing ? handleUpdate : handleSubmit}
                  disabled={btnLoading}
                >
                  {btnLoading ? <Spinner /> : editing ? "Update" : "Submit"}
                </button>
                <button className="btn btn-danger" onClick={resetFields}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        <Sidebar isSidebarOpen={isSidebarOpen} />
        <div className="innerRight">
          <TopBar
            title="Purchased Tools &amp; Subscriptions Details"
            menu=""
            toggleSidebar={toggleSidebar}
          />
          <div className="officersSec">
            <div className="row align-items-center mb-3">
              <div className="col-sm-6 col-6">
                <h3 className="colorHeadThree mb-0">
                  Purchased Tools &amp; Subscriptions Details
                </h3>
              </div>
              <div className="col-sm-6 col-6 text-right">
                <button
                  className="btn btn-primary"
                  onClick={() => setAddNewPopup(true)}
                >
                  <i className="fas fa-user-circle me-2" />
                  Add New
                </button>
                <button
                  className="btn btn-primary ms-3"
                  onClick={exportToExcel}
                  disabled={loading}
                >
                  Download Sheet <i class="far fa-file-excel ms-2" />
                </button>
              </div>
            </div>
            {allServices?.length > 0 ? (
              <div className="tableScroller">
                <table className="table table-striped">
                  <thead style={{ whiteSpace: "nowrap" }}>
                    <tr>
                      <th scope="col">Action</th>
                      <th scope="col">Tool Name</th>
                      <th scope="col">Tool Email</th>
                      <th scope="col">Tool Password</th>
                      <th scope="col">Tool Account</th>
                      <th scope="col">Plan Duration</th>
                      <th scope="col">Payment Mode</th>
                      <th scope="col">Start Date</th>
                      <th scope="col">Expiry Date</th>
                      <th scope="col">Tool Cost</th>
                      <th scope="col">Contact Name</th>
                      <th scope="col">Contact Email</th>
                      <th scope="col">Contact Phone</th>
                    </tr>
                  </thead>
                  <tbody style={{ whiteSpace: "nowrap" }}>
                    {allServices &&
                      allServices?.length > 0 &&
                      allServices?.map((item, i) => (
                        <>
                          <tr key={i}>
                            <td>
                              <div className="tIco">
                                <i
                                  className="fas fa-pencil-alt me-2"
                                  onClick={(event) => {
                                    event.stopPropagation();

                                    setData(item);
                                  }}
                                />{" "}
                                <i
                                  className="fas fa-trash-alt me-2"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setSelectedService(item);
                                    setDeleteServicePopup(true);
                                  }}
                                />{" "}
                              </div>
                            </td>
                            <td>
                              <p className="tData">
                                <img
                                  src={`https://cdn.simpleicons.org/${item.toolName
                                    ?.toLowerCase()
                                    .replace(/\s+/g, "")}`}
                                  alt={item.toolName}
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                    verticalAlign: "middle",
                                  }}
                                  onError={(e) =>
                                    (e.target.style.display = "none")
                                  }
                                />
                                {item?.toolName}
                              </p>
                            </td>
                            <td>
                              <p className="tData">
                                {item?.toolEmailId || "-"}
                              </p>
                            </td>
                            <td>
                              <p className="tData">{item?.password || "-"}</p>
                            </td>
                            <td>
                              <p className="tData">
                                {item?.accountNumber || "-"}
                              </p>
                            </td>
                            <td>
                              <p className="tData text-capitalize">
                                {item?.planDuration}
                              </p>
                            </td>
                            <td>
                              <p className="tData">{item?.paymentMode || "-"}</p>
                            </td>
                            <td>
                              <p className="tData">
                                {item?.startDate
                                  ? moment(item?.startDate).format("MM/DD/YYYY")
                                  : "-"}
                              </p>
                            </td>
                            <td>
                              <p className="tData">
                                {item?.expiryDate
                                  ? moment(item?.expiryDate).format(
                                    "MM/DD/YYYY",
                                  )
                                  : "-"}
                              </p>
                            </td>
                            <td>
                              <p className="tData">$ {item?.cost}</p>
                            </td>
                            <td>
                              <p className="tData">{item?.name || "-"}</p>
                            </td>
                            <td>
                              <p className="tData">{item?.email || "-"}</p>
                            </td>
                            <td>
                              <p className="tData">{item?.phoneNo || "-"}</p>
                            </td>
                          </tr>
                        </>
                      ))}
                  </tbody>
                </table>
              </div>
            ) : (
              !loading && (
                <div className="text-center mt-4">
                  <img src={NotFound} alt="noData" className="noData mb-2" />
                  <p className="m-0">No Officers Found.</p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <Modal
        show={deleteServicePopup}
        onHide={() => {
          resetFields();
          setDeleteServicePopup(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedService?.toolName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p className="mb-0">
              Are you sure you want to DELETE these tool details?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleDeleteOfficer}
            disabled={btnLoading}
          >
            {btnLoading ? <Spinner /> : "Delete"}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              setDeleteServicePopup(false);
              resetFields();
            }}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServicePurchased;
